import '@babel/polyfill'
import 'mutationobserver-shim'
import Vue from 'vue'
import './plugins/bootstrap-vue'
import './plugins/vue-fragment'
import './jquery'
import App from './App.vue'

import router from './router'
import store from './store'

// Highlow css
import './assets/css/font.css'
import './assets/css/main-split.css'

// Bootstrap override
import './assets/css/custom.scss'

// Momentjs
Vue.use(require('vue-moment'));

// Cookies
Vue.use(require('vue-cookie'))

// i18n
// // import en from './locales/en.json'
// // import ja from './locales/ja.json'
// // import VueI18n from 'vue-i18n'
// // Vue.use(VueI18n);
// import { defaultLocale, localeOptions} from './config'
// const messages = { en: en, ja: ja };
// const locale = (localStorage.getItem('currentLanguage') && localeOptions.filter(x => x.id === localStorage.getItem('currentLanguage')).length > 0) ? localStorage.getItem('currentLanguage') : defaultLocale;
// const i18n = new VueI18n({
//   locale: locale,
//   fallbackLocale: 'en',
//   messages
// });

//
import i18n from './i18n'


Vue.config.productionTip = false

new Vue({
  i18n,
  router,
  store,
  render: h => h(App),
}).$mount('#app')
